import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class SiteFaqCategory extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/site/faqCategory'
    super(store, path)
  }
}
